<template>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm">

          <!-- 카드 바디 -->
          <div class="card-body pt-0">
            <!-- 등록 버튼 -->
            <div class="d-flex justify-content-end align-items-center gap-2 mt-3">

              <input
                type="text"
                class="form-control"
                style="width:100px;"
                v-model="crtCount"
              />

              <button type="button" class="btn btn-success" style="margin-bottom: 0;" @click="onClickCreate">
                이벤트 등록
              </button>

            </div>
            <DataGen1 ref="dataGen1"/>
            <DataGen2 ref="dataGen2"/>
            <DataGen3 ref="dataGen3"/>
            <DataGen4 ref="dataGen4"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataGen1 from "@/views/dataGen/Gen1.vue";
import DataGen2 from "@/views/dataGen/Gen2.vue";
import DataGen3 from "@/views/dataGen/Gen3.vue";
import DataGen4 from "@/views/dataGen/Gen4.vue";

export default {
  name: "EventCreate",
  components: {
    DataGen1,
    DataGen2,
    DataGen3,
    DataGen4,
  },
  data() {
    return {
      crtCount: 1,
    }
  },
  methods: {
    async onClickCreate() {
      const delay = (ms) => new Promise(r => setTimeout(r, ms));

      const n = Number(this.crtCount) || 1
      if (!this.$refs.dataGen1) return
      const resultList1 = await this.$refs.dataGen1.submitEventMulti(n)
      console.log('resultList1:')
      console.log(resultList1)
      await delay(2000);
      if(!resultList1 && resultList1.length == 0) return;
      await this.$refs.dataGen2.fromStep1(resultList1);
      await delay(2000);
      const resultList2 = await this.$refs.dataGen3.fromStep2(resultList1);
      await delay(2000);
      if(!resultList2 && resultList2.length == 0) return;
      console.log('resultList2:')
      console.log(resultList2)
      await this.$refs.dataGen4.fromStep3(resultList2, resultList1);
    }
  }
};
</script>

<style scoped>

</style>
